export default __webpack_public_path__ + "static/media/personImage.8fd1be68.svg";